export default "dab54069e92c4a87.svg"